import React, { Component } from "react";
import Slider from "react-slick";
import $ from 'jquery';
import Lightbox from 'lightbox-react';
/**
 * Subotica
 */
import suboticaFirstImg from '../images/subotica/grad01.jpg';
import suboticaSecondImg from '../images/subotica/grad02.jpg';
import suboticaThirdImg from '../images/subotica/grad03.jpg';
import suboticaFourthImg from '../images/subotica/grad04.jpg';
import suboticaFifthImg from '../images/subotica/grad05.jpg';

/**
 * Palic
 */
import palicFirstImg from '../images/palic/park_palic_map.jpg';
import palicSecondImg from '../images/palic/pp01.jpg';
import palicThirdImg from '../images/palic/pplogo.jpg';

/**
 * Bic
 */
import bicFirstImg from '../images/BIC/10.jpg';
import bicSecondImg from '../images/BIC/11.jpg';
import bicThirdImg from '../images/BIC/12.jpg';
import bicFourthImg from '../images/BIC/13.jpg';
import bicFifthImg from '../images/BIC/14.jpg';
import bicSixthImg from '../images/BIC/15.jpg';
import bicSeventhImg from '../images/BIC/15b.jpg';
import bicEighthImg from '../images/BIC/16.jpg';
import bicNinthImg from '../images/BIC/17.jpg';
/**
 * Smatsa - sart
 */
import sartFirstImg from '../images/sart/flajer.jpg';
import sartSecondImg from '../images/sart/izvestaj.jpg';
import sartThirdImg from '../images/sart/Smatsa-report.jpg';
import sartFourthImg from '../images/sart/Smatsa-report-2.jpg';

/**
 * Mlekara
 */
import mlekaraFirstImg from '../images/mlekara/mlekara02.jpg';
import mlekaraSecondImg from '../images/mlekara/mlekara03.jpg';
import mlekaraThirdImg from '../images/mlekara/mlekara04.jpg';
import mlekaraFourthImg from '../images/mlekara/mlekara05.jpg';
import mlekaraFifthImg from '../images/mlekara/mlekara06.jpg';
import mlekaraSixthImg from '../images/mlekara/mlekara07.jpg';
import mlekaraSeventhImg from '../images/mlekara/mlekara08.jpg';
import mlekaraEighthImg from '../images/mlekara/smart1.jpg';

/**
 * Direkcija
 */

import direkcijaFirstImg from '../images/direkcija/jpdirekcija01.jpg';

/**
 * ETP
 */
import etpFirstImg from '../images/etp/ptp01.jpg';
import etpSecondImg from '../images/etp/ptp02.jpg';
import etpThirdImg from '../images/etp/smart3.jpg';

/**
 * Fabrika Zabave
 */
import FaZaFirst from '../images/fabrika-zabave/Fabrika-rodjendan-pozivnica.jpg';
import FaZaSecond from '../images/fabrika-zabave/Fabrika-zabave-materijal-za-sto.jpg';
import FaZaThird from '../images/fabrika-zabave/Fabrika-zabave-memo.jpg';
import FaZaFourth from '../images/fabrika-zabave/Fabrika-zabave-picovnik.jpg';
import FaZaFifth from '../images/fabrika-zabave/Fabrika-zabave-pozivnica.jpg';
import FaZaSixth from '../images/fabrika-zabave/Fabrika-zabave-puzzle.jpg';
import FaZaSeventh from '../images/fabrika-zabave/Fabrika-zabave-roll-up.jpg';
import FaZaEighth from '../images/fabrika-zabave/Fabrika-zabave-web-ad.jpg';

/**
 * Fina Vaterpolo
 */
import finaVatFirstImg from '../images/fina-vaterpolo/layout-Program-MEMO-ID-TEAM-GUIDE-3.jpg';
import finaVatSecondImg from '../images/fina-vaterpolo/Program-real-life.jpg';
import finaVatThirdImg from '../images/fina-vaterpolo/zastitni-znak-1.jpg';

/**
 * Nutrikasa
 */
import nutrikasaFirstImg from '../images/nutrikasa/NK-FB-2-avgust.jpg';
import nutrikasaSecondImg from '../images/nutrikasa/NK-FB-3-avgust.jpg';
import nutrikasaThirdImg from '../images/nutrikasa/Nutri-Kasa.jpg';
import nutrikasaFourthImg from '../images/nutrikasa/Nutri-Kasa-2.jpg';
import nutrikasaFifthImg from '../images/nutrikasa/Nutri-Kasa-social-media.jpg';

/**
 * Primus
 */
import primusFirstImg from '../images/primus/Primus-fb.jpg';
import primusSecondImg from '../images/primus/su-led-01.jpg';
import primusThirdImg from '../images/primus/Tri-Fold-Brochure-PSD-Mockup.jpg';
import primusFourthImg from '../images/primus/Z-Fold-Brochure-PSD-Mockup.jpg';

/**
 * Regionalna Deponija
 */
import regionalFirstImg from '../images/regionalna-deponija/reg-dep-kamion-branding.jpg';
import regionalSecondImg from '../images/regionalna-deponija/Reg-Dep-startionary.jpg';
import regionalThirdImg from '../images/regionalna-deponija/Reg-Dep-web-sajt.jpg';
import regionalFourthImg from '../images/regionalna-deponija/Reg-Dep-web-sajt-2.jpg';
import regionalFifthImg from '../images/regionalna-deponija/Reg-Dep-web-sajt-3.jpg';

/**
 * Visa Prom
 */
import visaPromFirstImg from '../images/visa-prom/VISA-PROM-logo.jpg';
import visaPromSecondImg from '../images/visa-prom/VISA-PROM-MEMO.jpg';
import visaPromThirdImg from '../images/visa-prom/VISA-PROM-papirna-kesa.jpg';
import visaPromFourthImg from '../images/visa-prom/VISA-PROM-SVE.jpg';
import visaPromFifthImg from '../images/visa-prom/VISA-PROM-VAN.jpg';
import visaPromSixthImg from '../images/visa-prom/VISA-PROM-zgrada.jpg';

/**
 * Al Pack
 */
import alPackFirstImg from '../images/AlPack/alpack01.jpg';
import alPackSecondImg from '../images/AlPack/alpack02.jpg';
import alPackThirdImg from '../images/AlPack/alpack03.jpg';
 /**
 * Office Shoes
 */
import officeShoesFirstImg from '../images/OfficeShoes/bilbord01.jpg';
import officeShoesSecondImg from '../images/OfficeShoes/bilbord03.jpg';
import officeShoesThirdImg from '../images/OfficeShoes/bilbord04.jpg';
import officeShoesFourthImg from '../images/OfficeShoes/osbaner02.jpg';
import officeShoesFifthImg from '../images/OfficeShoes/osbrosura01.jpg';
import officeShoesSixthImg from '../images/OfficeShoes/oskatalog01.jpg';
import officeShoesSeventhImg from '../images/OfficeShoes/oskatalog02.jpg';
import officeShoesEighthImg from '../images/OfficeShoes/osoglas01.jpg';
import officeShoesNinthImg from '../images/OfficeShoes/osoglas02.jpg';
import officeShoesTenthImg from '../images/OfficeShoes/osoglas03.jpg';
import officeShoesEleventhImg from '../images/OfficeShoes/osoglas04.jpg';
 /**
 * Zvonko Bogdan
 */
import zvonkoBogdanFirstImg from '../images/ZB/cd-za-veb.jpg';
 /**
 * DG
 */
import dgFirstImg from '../images/DG/dg.jpg';

 /**
 * Gloria
 */
import glorijaFirstImg from '../images/Glorija/hotelgloriabrosura.jpg';
import glorijaSecondImg from '../images/Glorija/hotelgloriacenovnik.jpg';
import glorijaThirdImg from '../images/Glorija/hotelgloriahanger.jpg';
import glorijaFourthImg from '../images/Glorija/hotelgloriaoglas.jpg';
import glorijaFifthImg from '../images/Glorija/hotelgloriaoglas02.jpg';
import glorijaSixthImg from '../images/Glorija/hotelgloriatelop.jpg';

 /**
 * AgroVojvodina
 */
import agroVojvodinaFirstImg from '../images/AgroVojvodina/agrovojvodina01.jpg';

 /**
 * VictoriaGroup
 */

/**
 * Lion Group
 */
import lionGroupFirstImg from '../images/LionGroup/liongroup01.jpg';
import lionGroupSecondImg from '../images/LionGroup/liongroupkorporativnipaket.jpg';
import lionGroupThirdImg from '../images/LionGroup/liongroupngcestitka.jpg';
import lionGroupFourthImg from '../images/LionGroup/liongroupngoglas.jpg';

/**
 * Goodwill
 */
import goodWillFirstImg from '../images/Goodwill/gwbilbord01.jpg';
import goodWillSecondImg from '../images/Goodwill/gwbilbord02.jpg';

/**
 * Longavita
 */
import logavitaFirstImg from '../images/Longavita/longavita01.jpg';
import logavitaSecondImg from '../images/Longavita/longavita02.jpg';
import logavitaThirdImg from '../images/Longavita/longavitapozivnica.jpg';

/**
 * kzler
 */
import lokalniRazvojFirstImg from '../images/Lokalni-Razvoj/ler02.jpg';
import lokalniRazvojSecondImg from '../images/Lokalni-Razvoj/ler04.jpg';

/**
 * MipSeeds
 */
import mipSeedsFirstImg from '../images/MipSeeds/8.jpg';

const imagesAlPack = [
    'img/AlPack/alpack01.jpg',
    'img/AlPack/alpack02.jpg',
    'img/AlPack/alpack03.jpg',
];
const imagesOffice = [
    'img/OfficeShoes/bilbord01.jpg',
    'img/OfficeShoes/bilbord03.jpg',
    'img/OfficeShoes/bilbord04.jpg',
    'img/OfficeShoes/osbaner02.jpg',
    'img/OfficeShoes/osbrosura01.jpg',
    'img/OfficeShoes/oskatalog01.jpg',
    'img/OfficeShoes/oskatalog02.jpg',
    'img/OfficeShoes/osoglas01.jpg',
    'img/OfficeShoes/osoglas02.jpg',
    'img/OfficeShoes/osoglas03.jpg',
    'img/OfficeShoes/osoglas04.jpg',
];
const imagesZB = [
    'img/ZB/cd-za-veb.jpg'
];
const imagesDG = [
    'img/DG/dg.jpg'
];
const imagesGloria = [
    'img/Glorija/hotelgloriabrosura.jpg',
    'img/Glorija/hotelgloriacenovnik.jpg',
    'img/Glorija/hotelgloriahanger.jpg',
    'img/Glorija/hotelgloriaoglas.jpg',
    'img/Glorija/hotelgloriaoglas02.jpg',
    'img/Glorija/hotelgloriatelop.jpg',
];
const imagesGoodwill = [
    'img/Goodwill/gwbilbord01.jpg',
    'img/Goodwill/gwbilbord02.jpg',
]
const imagesAgroV = [
    'img/AgroVojvodina/agrovojvodina01.jpg',
];
const imagesLionGroup = [
    'img/LionGroup/liongroup01.jpg',
    'img/LionGroup/liongroupkorporativnipaket.jpg',
    'img/LionGroup/liongroupngcestitka.jpg',
    'img/LionGroup/liongroupngoglas.jpg',
];
const imagesLongavita = [
    'img/Longavita/longavita01.jpg',
    'img/Longavita/longavita02.jpg',
    'img/Longavita/longavitapozivnica.jpg',
];
const imageslokalniRazvoj = [
    'img/Lokalni-Razvoj/ler02.jpg',
    'img/Lokalni-Razvoj/ler04.jpg',
];
const imagesMipSeeds = [
    'img/MipSeeds/8.jpg',
]
const imagesSubotica = [
    'img/grad01.jpg',
    'img/grad02.jpg',
    'img/grad03.jpg',
    'img/grad04.jpg',
    'img/grad05.jpg',
];
const imagesPalic = [
    'img/park_palic_map.jpg',
    'img/pp01.jpg',
    'img/pplogo.jpg',
];
const imagesBic = [
    'img/BIC/10.jpg',
    'img/BIC/11.jpg',
    'img/BIC/12.jpg',
    'img/BIC/13.jpg',
    'img/BIC/14.jpg',
    'img/BIC/15.jpg',
    'img/BIC/15b.jpg',
    'img/BIC/16.jpg',
    'img/BIC/17.jpg',
];
const imagesSart = [
    'img/flajer.jpg',
    'img/izvestaj.jpg',
    'img/Smatsa-report.jpg',
    'img/Smatsa-report-2.jpg',
];
const imagesMlekara = [
    'img/mlekara02.jpg',
    'img/mlekara03.jpg',
    'img/mlekara04.jpg',
    'img/mlekara05.jpg',
    'img/mlekara06.jpg',
    'img/mlekara07.jpg',
    'img/mlekara08.jpg',
    'img/smart1.jpg',
];
const imagesDirekcija = [
    'img/jpdirekcija01.jpg',
];
const imagesEtp = [
    'img/ptp01.jpg',
    'img/ptp02.jpg',
    'img/smart3.jpg',
];
const imagesFabrikaZabave = [
    'img/fabrika-zabave/Fabrika-rodjendan-pozivnica.jpg',
    'img/fabrika-zabave/Fabrika-zabave-materijal-za-sto.jpg',
    'img/fabrika-zabave/Fabrika-zabave-memo.jpg',
    'img/fabrika-zabave/Fabrika-zabave-picovnik.jpg',
    'img/fabrika-zabave/Fabrika-zabave-pozivnica.jpg',
    'img/fabrika-zabave/Fabrika-zabave-puzzle.jpg',
    'img/fabrika-zabave/Fabrika-zabave-roll-up.jpg',
    'img/fabrika-zabave/Fabrika-zabave-web-ad.jpg',
];
const imagesFinaVat = [
  'img/fina-vaterpolo/layout-Program-MEMO-ID-TEAM-GUIDE-3.jpg',
  'img/fina-vaterpolo/Program-real-life.jpg',
  'img/fina-vaterpolo/zastitni-znak-1.jpg',
];
const imagesNutrikasa = [
    'img/nutrikasa/NK-FB-2-avgust.jpg',
    'img/nutrikasa/NK-FB-3-avgust.jpg',
    'img/nutrikasa/Nutri-Kasa.jpg',
    'img/nutrikasa/Nutri-Kasa-2.jpg',
    'img/nutrikasa/Nutri-Kasa-social-media.jpg',
];
const imagesPrimus = [
    'img/primus/Primus-fb.jpg',
    'img/primus/su-led-01.jpg',
    'img/primus/Tri-Fold-Brochure-PSD-Mockup.jpg',
    'img/primus/Z-Fold-Brochure-PSD-Mockup.jpg',
];
const imagesRegionalDep = [
    'img/regionalna-deponija/reg-dep-kamion-branding.jpg',
    'img/regionalna-deponija/Reg-Dep-startionary.jpg',
    'img/regionalna-deponija/Reg-Dep-web-sajt.jpg',
    'img/regionalna-deponija/Reg-Dep-web-sajt-2.jpg',
    'img/regionalna-deponija/Reg-Dep-web-sajt-3.jpg',
];
const imagesVisaProm = [
    'img/visa-prom/VISA-PROM-logo.jpg',
    'img/visa-prom/VISA-PROM-MEMO.jpg',
    'img/visa-prom/VISA-PROM-papirna-kesa.jpg',
    'img/visa-prom/VISA-PROM-SVE.jpg',
    'img/visa-prom/VISA-PROM-VAN.jpg',
    'img/visa-prom/VISA-PROM-zgrada.jpg',
];

/**
 * AlPack images
 */
let alpackFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${alPackFirstImg})`
}
let alpackSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${alPackSecondImg})`
}
let alpackThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${alPackThirdImg})`
}

/**
 * AgroVojvodina
 */
let agroVojvodinaFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${agroVojvodinaFirstImg})`
}

/**
 * DG
 */
let dgFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${dgFirstImg})`
}

/**
 * Glorija
 */
let glorijaFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${glorijaFirstImg})`
}
let glorijaSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${glorijaSecondImg})`
}
let glorijaThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${glorijaThirdImg})`
}
let glorijaFourth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${glorijaFourthImg})`
}
let glorijaFifth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${glorijaFifthImg})`
}
let glorijaSixth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${glorijaSixthImg})`
}

/**
 * Goodwill
 */
let goodWillFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${goodWillFirstImg})`
}
let goodWillSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${goodWillSecondImg})`
}

/**
 * Lion Group
 */

let lionGroupFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${lionGroupFirstImg})`
}
let lionGroupSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${lionGroupSecondImg})`
}
let lionGroupThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${lionGroupThirdImg})`
}
let lionGroupFourth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${lionGroupFourthImg})`
}

/**
 * Lokalni Razvoj
 */
let lokalniRazvojFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${lokalniRazvojFirstImg})`
}
let lokalniRazvojSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${lokalniRazvojSecondImg})`
}
/**
 * Longavita
 */
let logavitaFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${logavitaFirstImg})`
}
let logavitaSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${logavitaSecondImg})`
}
let longavitaThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${logavitaThirdImg})`
}

/**
 * MipSeeds
 */
let mipSeedsFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${mipSeedsFirstImg})`
}

/**
 * OfficeShoes
 */
let officeShoesFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${officeShoesFirstImg})`
}
let officeShoesSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${officeShoesSecondImg})`
}
let officeShoesThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${officeShoesThirdImg})`
}
let officeShoesFourth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${officeShoesFourthImg})`
}
let officeShoesFifth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${officeShoesFifthImg})`
}
let officeShoesSixth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${officeShoesSixthImg})`
}
let officeShoesSeventh = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${officeShoesSeventhImg})`
}
let officeShoesEighth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${officeShoesEighthImg})`
}
let officeShoesNinth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${officeShoesNinthImg})`
}
let officeShoesTenth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${officeShoesTenthImg})`
}
let officeShoesEleventh = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${officeShoesEleventhImg})`
}

/**
 * Zvonko Bogda
 */
let zbFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${zvonkoBogdanFirstImg})`
}

/**
 * Subotica
 * @type {{backgroundPosition: string, backgroundSize: string, backgroundImage: string}}
 */
let suboticaFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${suboticaFirstImg})`
};
let suboticaSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${suboticaSecondImg})`
};
let suboticaThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${suboticaThirdImg})`
};
let suboticaFourth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${suboticaFourthImg})`
};
let suboticaFifth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${suboticaFifthImg})`
};
/**
 * Palic
 * @type {{backgroundPosition: string, backgroundSize: string, backgroundImage: string}}
 */
let palicFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${palicFirstImg})`
};
let palicSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${palicSecondImg})`
};
let palicThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${palicThirdImg})`
};
/**
 * Bic
 */
let bicFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${bicFirstImg})`
};
let bicSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${bicSecondImg})`
};
let bicThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${bicThirdImg})`
};
let bicFourth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${bicFourthImg})`
};
let bicFifth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${bicFifthImg})`
};
let bicSixth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${bicSixthImg})`
};
let bicSeventh = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${bicSeventhImg})`
};
let bicEighth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${bicEighthImg})`
};
let bicNinth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${bicNinthImg})`
};

/**
 * Smatsa - sart
 * @type {{backgroundPosition: string, backgroundSize: string, backgroundImage: string}}
 */
let sartFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${sartFirstImg})`
};
let sartSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${sartSecondImg})`
};
let sartThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${sartThirdImg})`
};
let sartFourth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${sartFourthImg})`
};

/**
 * Mlekara
 * @type {{backgroundPosition: string, backgroundSize: string, backgroundImage: string}}
 */

let mlekaraFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${mlekaraFirstImg})`
};
let mlekaraSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${mlekaraSecondImg})`
};
let mlekaraThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${mlekaraThirdImg})`
};
let mlekaraFourth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${mlekaraFourthImg})`
};
let mlekaraFifth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${mlekaraFifthImg})`
};
let mlekaraSixth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${mlekaraSixthImg})`
};
let mlekaraSeventh = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${mlekaraSeventhImg})`
};
let mlekaraEighth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${mlekaraEighthImg})`
};

/**
 * Direkcija
 * @type {{backgroundPosition: string, backgroundSize: string, backgroundImage: string}}
 */
let direkcijaFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${direkcijaFirstImg})`
};

/**
 * ETP
 * @type {{backgroundPosition: string, backgroundSize: string, backgroundImage: string}}
 */
let etpFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${etpFirstImg})`
};
let etpSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${etpSecondImg})`
};
let etpThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${etpThirdImg})`
};

/**
 * Fabrika Zabave
 * @type {{backgroundPosition: string, backgroundSize: string, backgroundImage: string}}
 */
let fabrikaFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${FaZaFirst})`
};
let fabrikaSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${FaZaSecond})`
};
let fabrikaThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${FaZaThird})`
};
let fabrikaFourth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${FaZaFourth})`
};
let fabrikaFifth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${FaZaFifth})`
};
let fabrikaSixth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${FaZaSixth})`
};
let fabrikaSeventh = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${FaZaSeventh})`
};
let fabrikaEighth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${FaZaEighth})`
};

/**
 * Fabrika Zabave
 * @type {{backgroundPosition: string, backgroundSize: string, backgroundImage: string}}
 */
let finaVatFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${finaVatFirstImg})`
};
let finaVatSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${finaVatSecondImg})`
};
let finaVatThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${finaVatThirdImg})`
};

/**
 * Nutrikasa
 * @type {{backgroundPosition: string, backgroundSize: string, backgroundImage: string}}
 */
let nutrikasaFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${nutrikasaFirstImg})`
};
let nutrikasaSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${nutrikasaSecondImg})`
};
let nutrikasaThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${nutrikasaThirdImg})`
};
let nutrikasaFourth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${nutrikasaFourthImg})`
};
let nutrikasaFifth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${nutrikasaFifthImg})`
};
/**
 * Primus
 * @type {{backgroundPosition: string, backgroundSize: string, backgroundImage: string}}
 */
let primusFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${primusFirstImg})`
};
let primusSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${primusSecondImg})`
};
let primusThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${primusThirdImg})`
};
let primusFourth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${primusFourthImg})`
};
/**
 * Regionalna Deponija
 * @type {{backgroundPosition: string, backgroundSize: string, backgroundImage: string}}
 */
let regionalFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${regionalFirstImg})`
};
let regionalSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${regionalSecondImg})`
};
let regionalThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${regionalThirdImg})`
};
let regionalFourth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${regionalFourthImg})`
};
let regionalFifth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${regionalFifthImg})`
};
/**
 * Visa Prom
 * @type {{backgroundPosition: string, backgroundSize: string, backgroundImage: string}}
 */
let visaPromFirst = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${visaPromFirstImg})`
};
let visaPromSecond = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${visaPromSecondImg})`
};
let visaPromThird = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${visaPromThirdImg})`
};
let visaPromFourth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${visaPromFourthImg})`
};
let visaPromFifth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${visaPromFifthImg})`
};
let visaPromSixth = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    backgroundImage: `url(${visaPromSixthImg})`
};



export default class SimpleSlider extends Component {

    componentDidMount() {
        $('.single-slick-wrapper img').on('click', function() {
            let target = $(this).parent().attr('data-id');
            console.log(target);
            $('.row').removeClass('opened');
            $('.'+target).addClass('opened');
        });
    }

    constructor(props) {
        super(props);
        this.state = {
            suboticaPhotoIndex: 0,
            palicPhotoIndex: 0,
            bicPhotoIndex: 0,
            sartPhotoIndex: 0,
            mlekaraPhotoIndex: 0,
            direkcijaPhotoIndex: 0,
            etpPhotoIndex: 0,
            fabrikaZabavePhotoIndex: 0,
            finaVatPhotoIndex: 0,
            nutrikasaPhotoIndex: 0,
            primusPhotoIndex: 0,
            regionalDepPhotoIndex: 0,
            visaPromPhotoIndex: 0,
            agroPhotoIndex: 0,
            alpackPhotoIndex: 0,
            dgPhotoIndex: 0,
            gloriaPhotoIndex: 0,
            goodwillPhotoIndex: 0,
            lionGroupPhotoIndex: 0,
            lokalniRazvojPhotoIndex: 0,
            longavitaPhotoIndex: 0,
            officeShoesPhotoIndex: 0,
            mipSeedsPhotoIndex: 0,
            zbPhotoIndex: 0,
            agroIsOpen: false,
            alpackIsOpen: false,
            dgIsOpen: false,
            gloriaIsOpen: false,
            goodwillIsOpen: false,
            lionGroupIsOpen: false,
            lokalniRazvojIsOpen: false,
            longavitaIsOpen: false,
            mipSeedsIsOpen: false,
            officeShoesIsOpen: false,
            zbIsOpen: false,
            suboticaIsOpen: false,
            palicIsOpen: false,
            bicIsOpen: false,
            sartIsOpen: false,
            mlekaraIsOpen: false,
            direkcijaIsOpen: false,
            etpIsOpen: false,
            fabrikaIsOpen: false,
            finaVatIsOpen: false,
            nutrikasaIsOpen: false,
            primusIsOpen: false,
            regionalDepIsOpen: false,
            visaPromIsOpen: false,
        };
    }

    render() {
        const {
            suboticaPhotoIndex,
            palicPhotoIndex,
            sartPhotoIndex,
            bicPhotoIndex,
            mlekaraPhotoIndex,
            direkcijaPhotoIndex,
            etpPhotoIndex,
            fabrikaZabavePhotoIndex,
            finaVatPhotoIndex,
            nutrikasaPhotoIndex,
            primusPhotoIndex,
            regionalDepPhotoIndex,
            visaPromPhotoIndex,
            suboticaIsOpen,
            palicIsOpen,
            bicIsOpen,
            sartIsOpen,
            mlekaraIsOpen,
            direkcijaIsOpen,
            etpIsOpen,
            fabrikaIsOpen,
            finaVatIsOpen,
            nutrikasaIsOpen,
            primusIsOpen,
            regionalDepIsOpen,
            visaPromIsOpen,
            agroPhotoIndex,
            alpackPhotoIndex,
            dgPhotoIndex,
            gloriaPhotoIndex,
            goodwillPhotoIndex,
            lionGroupPhotoIndex,
            lokalniRazvojPhotoIndex,
            longavitaPhotoIndex,
            officeShoesPhotoIndex,
            zbPhotoIndex,
            mipSeedsPhotoIndex,
            mipSeedsIsOpen,
            agroIsOpen,
            alpackIsOpen,
            dgIsOpen,
            gloriaIsOpen,
            goodwillIsOpen,
            lionGroupIsOpen,
            lokalniRazvojIsOpen,
            longavitaIsOpen,
            officeShoesIsOpen,
            zbIsOpen,
        } = this.state;
        
        const settings = {
            arrows: true,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        };

        return (
            <div className="slick-wrapper">
                <Slider {...settings}>
                    <div className="single-slick-wrapper" data-id="subotica">
                        <img className="single-slick-image-slide" src="img/logos/Grad.svg" alt="subotica grad"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="palic">
                        <img className="single-slick-image-slide" src="img/logos/PPalic.svg" alt="park palic"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="bic">
                        <img className="single-slick-image-slide" src="img/logos/Bic.svg" alt="BIC"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="fabrika">
                        <img className="single-slick-image-slide"
                             src="img/logos/fabrika-zabave-beli-logo.png" alt="fabrika zabave"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="fina">
                        <img className="single-slick-image-slide"
                             src="img/logos/Fina-logo.png" alt="fina vaterpolo"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="nutrikasa">
                        <img className="single-slick-image-slide"
                             src="img/logos/nutrikasa-beli-logo.png" alt="nutrikasa"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="primus">
                        <img className="single-slick-image-slide"
                             src="img/logos/primus-beli-logo.png" alt="primus"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="regional">
                        <img className="single-slick-image-slide"
                             src="img/logos/Regionalna-Deponija-logo.png" alt="regionalna deponija"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="sart">
                        <img className="single-slick-image-slide" src="img/logos/Smtsa.svg" alt="sart"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="visa">
                        <img className="single-slick-image-slide"
                             src="img/logos/visa-prom-beli-logo.png" alt="visa prom"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="mlekara">
                        <img className="single-slick-image-slide" src="img/logos/Mlekara.svg" alt="mlekara subotica"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="alpack">
                        <img className="single-slick-image-slide" src="img/logos/APack.svg" alt="al pack"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="office-shoes">
                        <img className="single-slick-image-slide" src="img/logos/Office.svg" alt="office shoes"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="direkcija">
                        <img className="single-slick-image-slide" src="img/logos/Direkcija.svg" alt="direkcija"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="etp">
                        <img className="single-slick-image-slide" src="img/logos/EParkovi.svg" alt="e parkovi"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="zvonko-b">
                        <img className="single-slick-image-slide" src="img/logos/ZBogdan.svg" alt="zvonko bogdan"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="dg">
                        <img className="single-slick-image-slide" src="img/logos/DG.svg" alt="dg"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="glorija">
                        <img className="single-slick-image-slide" src="img/logos/Glorija.png" alt="glorija"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="agrovojvodina">
                        <img className="single-slick-image-slide" src="img/logos/AgoroV.svg" alt="agrovojvodina"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="victoria-group">
                        <img className="single-slick-image-slide" src="img/logos/ViktorijaG.svg" alt="viktorija group"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="lion-group">
                        <img className="single-slick-image-slide" src="img/logos/LionG.png" alt="lion group"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="goodwill">
                        <img className="single-slick-image-slide" src="img/logos/GoodWille.svg" alt="goodwill"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="longavita">
                        <img className="single-slick-image-slide" src="img/logos/longavita.png" alt="longavita"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="kzlr">
                        <img className="single-slick-image-slide" src="img/logos/Kancelarija.svg" alt="kancelarija za lokalni razvoj"/>
                    </div>
                    <div className="single-slick-wrapper" data-id="mipseeds">
                        <img className="single-slick-image-slide" src="img/logos/MiPS.svg" alt="mip seeds"/>
                    </div>
                </Slider>
                {zbIsOpen &&
                    <Lightbox
                        mainSrc={imagesZB[zbPhotoIndex]}
                        nextSrc={imagesZB[(zbPhotoIndex + 1) % imagesZB.length]}
                        prevSrc={imagesZB[(zbPhotoIndex + imagesZB.length - 1) % imagesZB.length]}
 
                        onCloseRequest={() => this.setState({ zbIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            zbPhotoIndex: (zbPhotoIndex + imagesZB.length - 1) % imagesZB.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            zbPhotoIndex: (zbPhotoIndex + 1) % imagesZB.length,
                        })}
                    />
                }
                {agroIsOpen &&
                    <Lightbox
                        mainSrc={imagesAgroV[agroPhotoIndex]}
                        nextSrc={imagesAgroV[(agroPhotoIndex + 1) % imagesAgroV.length]}
                        prevSrc={imagesAgroV[(agroPhotoIndex + imagesAgroV.length - 1) % imagesAgroV.length]}
 
                        onCloseRequest={() => this.setState({ agroIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            agroPhotoIndex: (agroPhotoIndex + imagesAgroV.length - 1) % imagesAgroV.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            agroPhotoIndex: (agroPhotoIndex + 1) % imagesAgroV.length,
                        })}
                    />
                }
                {alpackIsOpen &&
                    <Lightbox
                        mainSrc={imagesAlPack[alpackPhotoIndex]}
                        nextSrc={imagesAlPack[(alpackPhotoIndex + 1) % imagesAlPack.length]}
                        prevSrc={imagesAlPack[(alpackPhotoIndex + imagesAlPack.length - 1) % imagesAlPack.length]}
 
                        onCloseRequest={() => this.setState({ alpackIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            alpackPhotoIndex: (alpackPhotoIndex + imagesAlPack.length - 1) % imagesAlPack.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            alpackPhotoIndex: (alpackPhotoIndex + 1) % imagesAlPack.length,
                        })}
                    />
                }
                {dgIsOpen &&
                    <Lightbox
                        mainSrc={imagesDG[dgPhotoIndex]}
                        nextSrc={imagesDG[(dgPhotoIndex + 1) % imagesDG.length]}
                        prevSrc={imagesDG[(dgPhotoIndex + imagesDG.length - 1) % imagesDG.length]}
 
                        onCloseRequest={() => this.setState({ dgIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            dgPhotoIndex: (dgPhotoIndex + imagesDG.length - 1) % imagesDG.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            dgPhotoIndex: (dgPhotoIndex + 1) % imagesDG.length,
                        })}
                    />
                }
                {gloriaIsOpen &&
                    <Lightbox
                        mainSrc={imagesGloria[gloriaPhotoIndex]}
                        nextSrc={imagesGloria[(gloriaPhotoIndex + 1) % imagesGloria.length]}
                        prevSrc={imagesGloria[(gloriaPhotoIndex + imagesGloria.length - 1) % imagesGloria.length]}
 
                        onCloseRequest={() => this.setState({ gloriaIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            gloriaPhotoIndex: (gloriaPhotoIndex + imagesGloria.length - 1) % imagesGloria.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            gloriaPhotoIndex: (gloriaPhotoIndex + 1) % imagesGloria.length,
                        })}
                    />
                }
                {goodwillIsOpen &&
                    <Lightbox
                        mainSrc={imagesGoodwill[goodwillPhotoIndex]}
                        nextSrc={imagesGoodwill[(goodwillPhotoIndex + 1) % imagesGoodwill.length]}
                        prevSrc={imagesGoodwill[(goodwillPhotoIndex + imagesGoodwill.length - 1) % imagesGoodwill.length]}
 
                        onCloseRequest={() => this.setState({ goodwillIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            goodwillPhotoIndex: (goodwillPhotoIndex + imagesGoodwill.length - 1) % imagesGoodwill.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            goodwillPhotoIndex: (goodwillPhotoIndex + 1) % imagesGoodwill.length,
                        })}
                    />
                }
                {lionGroupIsOpen &&
                    <Lightbox
                        mainSrc={imagesLionGroup[lionGroupPhotoIndex]}
                        nextSrc={imagesLionGroup[(lionGroupPhotoIndex + 1) % imagesLionGroup.length]}
                        prevSrc={imagesLionGroup[(lionGroupPhotoIndex + imagesLionGroup.length - 1) % imagesLionGroup.length]}
 
                        onCloseRequest={() => this.setState({ lionGroupIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            lionGroupPhotoIndex: (lionGroupPhotoIndex + imagesLionGroup.length - 1) % imagesLionGroup.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            lionGroupPhotoIndex: (lionGroupPhotoIndex + 1) % imagesLionGroup.length,
                        })}
                    />
                }
                {lokalniRazvojIsOpen &&
                    <Lightbox
                        mainSrc={imageslokalniRazvoj[lokalniRazvojPhotoIndex]}
                        nextSrc={imageslokalniRazvoj[(lokalniRazvojPhotoIndex + 1) % imageslokalniRazvoj.length]}
                        prevSrc={imageslokalniRazvoj[(lokalniRazvojPhotoIndex + imageslokalniRazvoj.length - 1) % imageslokalniRazvoj.length]}
 
                        onCloseRequest={() => this.setState({ lokalniRazvojIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            lokalniRazvojPhotoIndex: (lokalniRazvojPhotoIndex + imageslokalniRazvoj.length - 1) % imageslokalniRazvoj.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            lokalniRazvojPhotoIndex: (lokalniRazvojPhotoIndex + 1) % imageslokalniRazvoj.length,
                        })}
                    />
                }
                {longavitaIsOpen &&
                    <Lightbox
                        mainSrc={imagesLongavita[longavitaPhotoIndex]}
                        nextSrc={imagesLongavita[(longavitaPhotoIndex + 1) % imagesLongavita.length]}
                        prevSrc={imagesLongavita[(longavitaPhotoIndex + imagesLongavita.length - 1) % imagesLongavita.length]}
 
                        onCloseRequest={() => this.setState({ longavitaIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            longavitaPhotoIndex: (longavitaPhotoIndex + imagesLongavita.length - 1) % imagesLongavita.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            longavitaPhotoIndex: (longavitaPhotoIndex + 1) % imagesLongavita.length,
                        })}
                    />
                }
                {mipSeedsIsOpen &&
                    <Lightbox
                        mainSrc={imagesMipSeeds[mipSeedsPhotoIndex]}
                        nextSrc={imagesMipSeeds[(mipSeedsPhotoIndex + 1) % imagesMipSeeds.length]}
                        prevSrc={imagesMipSeeds[(mipSeedsPhotoIndex + imagesMipSeeds.length - 1) % imagesMipSeeds.length]}
 
                        onCloseRequest={() => this.setState({ mipSeedsIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            mipSeedsPhotoIndex: (mipSeedsPhotoIndex + imagesMipSeeds.length - 1) % imagesMipSeeds.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            mipSeedsPhotoIndex: (mipSeedsPhotoIndex + 1) % imagesMipSeeds.length,
                        })}
                    />
                }
                {officeShoesIsOpen &&
                    <Lightbox
                        mainSrc={imagesOffice[officeShoesPhotoIndex]}
                        nextSrc={imagesOffice[(officeShoesPhotoIndex + 1) % imagesOffice.length]}
                        prevSrc={imagesOffice[(officeShoesPhotoIndex + imagesOffice.length - 1) % imagesOffice.length]}
 
                        onCloseRequest={() => this.setState({ officeShoesIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            officeShoesPhotoIndex: (officeShoesPhotoIndex + imagesOffice.length - 1) % imagesOffice.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            officeShoesPhotoIndex: (officeShoesPhotoIndex + 1) % imagesOffice.length,
                        })}
                    />
                }



                
                {suboticaIsOpen &&
                    <Lightbox
                        mainSrc={imagesSubotica[suboticaPhotoIndex]}
                        nextSrc={imagesSubotica[(suboticaPhotoIndex + 1) % imagesSubotica.length]}
                        prevSrc={imagesSubotica[(suboticaPhotoIndex + imagesSubotica.length - 1) % imagesSubotica.length]}
 
                        onCloseRequest={() => this.setState({ suboticaIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            suboticaPhotoIndex: (suboticaPhotoIndex + imagesSubotica.length - 1) % imagesSubotica.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            suboticaPhotoIndex: (suboticaPhotoIndex + 1) % imagesSubotica.length,
                        })}
                    />
                }
                {palicIsOpen &&
                    <Lightbox
                        mainSrc={imagesPalic[palicPhotoIndex]}
                        nextSrc={imagesPalic[(palicPhotoIndex + 1) % imagesPalic.length]}
                        prevSrc={imagesPalic[(palicPhotoIndex + imagesPalic.length - 1) % imagesPalic.length]}
 
                        onCloseRequest={() => this.setState({ palicIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            palicPhotoIndex: (palicPhotoIndex + imagesPalic.length - 1) % imagesPalic.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            palicPhotoIndex: (palicPhotoIndex + 1) % imagesPalic.length,
                        })}
                    />
                }
                {sartIsOpen &&
                    <Lightbox
                        mainSrc={imagesSart[sartPhotoIndex]}
                        nextSrc={imagesSart[(sartPhotoIndex + 1) % imagesSart.length]}
                        prevSrc={imagesSart[(sartPhotoIndex + imagesSart.length - 1) % imagesSart.length]}
 
                        onCloseRequest={() => this.setState({ sartIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            sartPhotoIndex: (sartPhotoIndex + imagesSart.length - 1) % imagesSart.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            sartPhotoIndex: (sartPhotoIndex + 1) % imagesSart.length,
                        })}
                    />
                }
                {bicIsOpen &&
                    <Lightbox
                        mainSrc={imagesBic[bicPhotoIndex]}
                        nextSrc={imagesBic[(bicPhotoIndex + 1) % imagesBic.length]}
                        prevSrc={imagesBic[(bicPhotoIndex + imagesBic.length - 1) % imagesBic.length]}
 
                        onCloseRequest={() => this.setState({ bicIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            bicPhotoIndex: (bicPhotoIndex + imagesBic.length - 1) % imagesBic.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            bicPhotoIndex: (bicPhotoIndex + 1) % imagesBic.length,
                        })}
                    />
                }
                {mlekaraIsOpen &&
                    <Lightbox
                        mainSrc={imagesMlekara[mlekaraPhotoIndex]}
                        nextSrc={imagesMlekara[(mlekaraPhotoIndex + 1) % imagesMlekara.length]}
                        prevSrc={imagesMlekara[(mlekaraPhotoIndex + imagesMlekara.length - 1) % imagesMlekara.length]}
 
                        onCloseRequest={() => this.setState({ mlekaraIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            mlekaraPhotoIndex: (mlekaraPhotoIndex + imagesMlekara.length - 1) % imagesMlekara.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            mlekaraPhotoIndex: (mlekaraPhotoIndex + 1) % imagesMlekara.length,
                        })}
                    />
                }
                {direkcijaIsOpen &&
                    <Lightbox
                        mainSrc={imagesDirekcija[direkcijaPhotoIndex]}
                        nextSrc={imagesDirekcija[(direkcijaPhotoIndex + 1) % imagesDirekcija.length]}
                        prevSrc={imagesDirekcija[(direkcijaPhotoIndex + imagesDirekcija.length - 1) % imagesDirekcija.length]}
 
                        onCloseRequest={() => this.setState({ direkcijaIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            direkcijaPhotoIndex: (direkcijaPhotoIndex + imagesDirekcija.length - 1) % imagesDirekcija.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            direkcijaPhotoIndex: (direkcijaPhotoIndex + 1) % imagesDirekcija.length,
                        })}
                    />
                }
                {etpIsOpen &&
                    <Lightbox
                        mainSrc={imagesEtp[etpPhotoIndex]}
                        nextSrc={imagesEtp[(etpPhotoIndex + 1) % imagesEtp.length]}
                        prevSrc={imagesEtp[(etpPhotoIndex + imagesEtp.length - 1) % imagesEtp.length]}
 
                        onCloseRequest={() => this.setState({ etpIsOpen: false })}
                        onMovePrevRequest={() => this.setState({
                            etpPhotoIndex: (etpPhotoIndex + imagesEtp.length - 1) % imagesEtp.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            etpPhotoIndex: (etpPhotoIndex + 1) % imagesEtp.length,
                        })}
                    />
                }
                {fabrikaIsOpen &&
                <Lightbox
                    mainSrc={imagesFabrikaZabave[fabrikaZabavePhotoIndex]}
                    nextSrc={imagesFabrikaZabave[(fabrikaZabavePhotoIndex + 1) % imagesFabrikaZabave.length]}
                    prevSrc={imagesFabrikaZabave[(fabrikaZabavePhotoIndex + imagesFabrikaZabave.length - 1) % imagesFabrikaZabave.length]}

                    onCloseRequest={() => this.setState({ fabrikaIsOpen: false })}
                    onMovePrevRequest={() => this.setState({
                        fabrikaZabavePhotoIndex: (fabrikaZabavePhotoIndex + imagesFabrikaZabave.length - 1) % imagesFabrikaZabave.length,
                    })}
                    onMoveNextRequest={() => this.setState({
                        fabrikaZabavePhotoIndex: (fabrikaZabavePhotoIndex + 1) % imagesFabrikaZabave.length,
                    })}
                />
                }
                {finaVatIsOpen &&
                <Lightbox
                    mainSrc={imagesFinaVat[finaVatPhotoIndex]}
                    nextSrc={imagesFinaVat[(finaVatPhotoIndex + 1) % imagesFinaVat.length]}
                    prevSrc={imagesFinaVat[(finaVatPhotoIndex + imagesFinaVat.length - 1) % imagesFinaVat.length]}

                    onCloseRequest={() => this.setState({ finaVatIsOpen: false })}
                    onMovePrevRequest={() => this.setState({
                        finaVatPhotoIndex: (finaVatPhotoIndex + imagesFinaVat.length - 1) % imagesFinaVat.length,
                    })}
                    onMoveNextRequest={() => this.setState({
                        finaVatPhotoIndex: (finaVatPhotoIndex + 1) % imagesFinaVat.length,
                    })}
                />
                }
                {nutrikasaIsOpen &&
                <Lightbox
                    mainSrc={imagesNutrikasa[nutrikasaPhotoIndex]}
                    nextSrc={imagesNutrikasa[(nutrikasaPhotoIndex + 1) % imagesNutrikasa.length]}
                    prevSrc={imagesNutrikasa[(nutrikasaPhotoIndex + imagesNutrikasa.length - 1) % imagesNutrikasa.length]}

                    onCloseRequest={() => this.setState({ nutrikasaIsOpen: false })}
                    onMovePrevRequest={() => this.setState({
                        nutrikasaPhotoIndex: (nutrikasaPhotoIndex + imagesNutrikasa.length - 1) % imagesNutrikasa.length,
                    })}
                    onMoveNextRequest={() => this.setState({
                        nutrikasaPhotoIndex: (nutrikasaPhotoIndex + 1) % imagesNutrikasa.length,
                    })}
                />
                }
                {primusIsOpen &&
                <Lightbox
                    mainSrc={imagesPrimus[primusPhotoIndex]}
                    nextSrc={imagesPrimus[(primusPhotoIndex + 1) % imagesPrimus.length]}
                    prevSrc={imagesPrimus[(primusPhotoIndex + imagesPrimus.length - 1) % imagesPrimus.length]}

                    onCloseRequest={() => this.setState({ primusIsOpen: false })}
                    onMovePrevRequest={() => this.setState({
                        primusPhotoIndex: (primusPhotoIndex + imagesPrimus.length - 1) % imagesPrimus.length,
                    })}
                    onMoveNextRequest={() => this.setState({
                        primusPhotoIndex: (primusPhotoIndex + 1) % imagesPrimus.length,
                    })}
                />
                }
                {regionalDepIsOpen &&
                <Lightbox
                    mainSrc={imagesRegionalDep[regionalDepPhotoIndex]}
                    nextSrc={imagesRegionalDep[(regionalDepPhotoIndex + 1) % imagesRegionalDep.length]}
                    prevSrc={imagesRegionalDep[(regionalDepPhotoIndex + imagesRegionalDep.length - 1) % imagesRegionalDep.length]}

                    onCloseRequest={() => this.setState({ regionalDepIsOpen: false })}
                    onMovePrevRequest={() => this.setState({
                        regionalDepPhotoIndex: (regionalDepPhotoIndex + imagesRegionalDep.length - 1) % imagesRegionalDep.length,
                    })}
                    onMoveNextRequest={() => this.setState({
                        regionalDepPhotoIndex: (regionalDepPhotoIndex + 1) % imagesRegionalDep.length,
                    })}
                />
                }
                {visaPromIsOpen &&
                <Lightbox
                    mainSrc={imagesVisaProm[visaPromPhotoIndex]}
                    nextSrc={imagesVisaProm[(visaPromPhotoIndex + 1) % imagesVisaProm.length]}
                    prevSrc={imagesVisaProm[(visaPromPhotoIndex + imagesVisaProm.length - 1) % imagesVisaProm.length]}

                    onCloseRequest={() => this.setState({ visaPromIsOpen: false })}
                    onMovePrevRequest={() => this.setState({
                        visaPromPhotoIndex: (visaPromPhotoIndex + imagesVisaProm.length - 1) % imagesVisaProm.length,
                    })}
                    onMoveNextRequest={() => this.setState({
                        visaPromPhotoIndex: (visaPromPhotoIndex + 1) % imagesVisaProm.length,
                    })}
                />
                }

                <section id="2_section">
                    <div className="project-section">
                        <div id="row" className="row subotica opened">
                            <div
                                className="single-project"
                                onClick={() => this.setState({ suboticaIsOpen: true, suboticaPhotoIndex: 0 })}
                                style={suboticaFirst}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ suboticaIsOpen: true, suboticaPhotoIndex: 1 })}
                                style={suboticaSecond}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ suboticaIsOpen: true, suboticaPhotoIndex: 2 })}
                                style={suboticaThird}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ suboticaIsOpen: true, suboticaPhotoIndex: 3 })}
                                style={suboticaFourth}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ suboticaIsOpen: true, suboticaPhotoIndex: 4 })}
                                style={suboticaFifth}>
                            </div>
                        </div>
                        <div id="row" className="row palic">
                            <div
                                className="single-project"
                                onClick={() => this.setState({ palicIsOpen: true, palicPhotoIndex: 0 })}
                                style={palicFirst}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ palicIsOpen: true, palicPhotoIndex: 1 })}
                                style={palicSecond}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ palicIsOpen: true, palicPhotoIndex: 2 })}
                                style={palicThird}>
                            </div>
                        </div>
                        <div id="row" className="row bic">
                            <div
                                className="single-project"
                                onClick={() => this.setState({ bicIsOpen: true, bicPhotoIndex: 0 })}
                                style={bicFirst}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ bicIsOpen: true, bicPhotoIndex: 1 })}
                                style={bicSecond}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ bicIsOpen: true, bicPhotoIndex: 2 })}
                                style={bicThird}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ bicIsOpen: true, bicPhotoIndex: 3 })}
                                style={bicFourth}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ bicIsOpen: true, bicPhotoIndex: 4 })}
                                style={bicFifth}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ bicIsOpen: true, bicPhotoIndex: 5 })}
                                style={bicSixth}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ bicIsOpen: true, bicPhotoIndex: 6 })}
                                style={bicSeventh}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ bicIsOpen: true, bicPhotoIndex: 7 })}
                                style={bicEighth}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ bicIsOpen: true, bicPhotoIndex: 8 })}
                                style={bicNinth}>
                            </div>
                        </div>
                        <div id="row" className="row sart">
                            <div
                                className="single-project"
                                onClick={() => this.setState({ sartIsOpen: true, sartPhotoIndex: 0 })}
                                style={sartFirst}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ sartIsOpen: true, sartPhotoIndex: 1 })}
                                style={sartSecond}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ sartIsOpen: true, sartPhotoIndex: 2 })}
                                style={sartThird}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ sartIsOpen: true, sartPhotoIndex: 3 })}
                                style={sartFourth}>
                            </div>
                        </div>
                        <div id="row" className="row mlekara">
                            <div
                                className="single-project"
                                onClick={() => this.setState({ mlekaraIsOpen: true, mlekaraPhotoIndex: 0 })}
                                style={mlekaraFirst}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ mlekaraIsOpen: true, mlekaraPhotoIndex: 1 })}
                                style={mlekaraSecond}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ mlekaraIsOpen: true, mlekaraPhotoIndex: 2 })}
                                style={mlekaraThird}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ mlekaraIsOpen: true, mlekaraPhotoIndex: 3 })}
                                style={mlekaraFourth}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ mlekaraIsOpen: true, mlekaraPhotoIndex: 4 })}
                                style={mlekaraFifth}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ mlekaraIsOpen: true, mlekaraPhotoIndex: 5 })}
                                style={mlekaraSixth}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ mlekaraIsOpen: true, mlekaraPhotoIndex: 6 })}
                                style={mlekaraSeventh}>
                            </div>
                            <div
                                className="single-project"
                                onClick={() => this.setState({ mlekaraIsOpen: true, mlekaraPhotoIndex: 7 })}
                                style={mlekaraEighth}>
                            </div>
                        </div>
                        <div id="row" className="row direkcija">
                            <div
                                className="single-project"
                                onClick={() => this.setState({ direkcijaIsOpen: true, direkcijaPhotoIndex: 0 })}
                                style={direkcijaFirst}>
                            </div>
                        </div>
                        <div id="row" className="row etp">
                            <div className="single-project"
                                 onClick={() => this.setState({ etpIsOpen: true, etpPhotoIndex: 0 })}
                                style={etpFirst}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ etpIsOpen: true, etpPhotoIndex: 1 })}
                                 style={etpSecond}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ etpIsOpen: true, etpPhotoIndex: 2 })}
                                 style={etpThird}>
                            </div>
                        </div>
                        <div id="row" className="row fabrika">
                            <div className="single-project"
                                 onClick={() => this.setState({ fabrikaIsOpen: true, fabrikaZabavePhotoIndex: 0 })}
                                 style={fabrikaFirst}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ fabrikaIsOpen: true, fabrikaZabavePhotoIndex: 1 })}
                                 style={fabrikaSecond}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ fabrikaIsOpen: true, fabrikaZabavePhotoIndex: 2 })}
                                 style={fabrikaThird}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ fabrikaIsOpen: true, fabrikaZabavePhotoIndex: 3 })}
                                 style={fabrikaFourth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ fabrikaIsOpen: true, fabrikaZabavePhotoIndex: 4 })}
                                 style={fabrikaFifth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ fabrikaIsOpen: true, fabrikaZabavePhotoIndex: 5 })}
                                 style={fabrikaSixth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ fabrikaIsOpen: true, fabrikaZabavePhotoIndex: 6 })}
                                 style={fabrikaSeventh}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ fabrikaIsOpen: true, fabrikaZabavePhotoIndex: 7 })}
                                 style={fabrikaEighth}>
                            </div>
                        </div>
                        <div id="row" className="row fina">
                            <div className="single-project"
                                 onClick={() => this.setState({ finaVatIsOpen: true, finaVatPhotoIndex: 0 })}
                                 style={finaVatFirst}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ finaVatIsOpen: true, finaVatPhotoIndex: 1 })}
                                 style={finaVatSecond}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ finaVatIsOpen: true, finaVatPhotoIndex: 2 })}
                                 style={finaVatThird}>
                            </div>
                        </div>
                        <div id="row" className="row nutrikasa">
                            <div className="single-project"
                                 onClick={() => this.setState({ nutrikasaIsOpen: true, nutrikasaPhotoIndex: 0 })}
                                 style={nutrikasaFirst}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ nutrikasaIsOpen: true, nutrikasaPhotoIndex: 1 })}
                                 style={nutrikasaSecond}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ nutrikasaIsOpen: true, nutrikasaPhotoIndex: 2 })}
                                 style={nutrikasaThird}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ nutrikasaIsOpen: true, nutrikasaPhotoIndex: 3 })}
                                 style={nutrikasaFourth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ nutrikasaIsOpen: true, nutrikasaPhotoIndex: 4 })}
                                 style={nutrikasaFifth}>
                            </div>
                        </div>
                        <div id="row" className="row primus">
                            <div className="single-project"
                                 onClick={() => this.setState({ primusIsOpen: true, primusPhotoIndex: 0 })}
                                 style={primusFirst}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ primusIsOpen: true, primusPhotoIndex: 1 })}
                                 style={primusSecond}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ primusIsOpen: true, primusPhotoIndex: 2 })}
                                 style={primusThird}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ primusIsOpen: true, primusPhotoIndex: 3 })}
                                 style={primusFourth}>
                            </div>
                        </div>
                        <div id="row" className="row regional">
                            <div className="single-project"
                                 onClick={() => this.setState({ regionalDepIsOpen: true, regionalDepPhotoIndex: 0 })}
                                 style={regionalFirst}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ regionalDepIsOpen: true, regionalDepPhotoIndex: 1 })}
                                 style={regionalSecond}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ regionalDepIsOpen: true, regionalDepPhotoIndex: 2 })}
                                 style={regionalThird}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ regionalDepIsOpen: true, regionalDepPhotoIndex: 3 })}
                                 style={regionalFourth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ regionalDepIsOpen: true, regionalDepPhotoIndex: 4 })}
                                 style={regionalFifth}>
                            </div>
                        </div>
                        <div id="row" className="row visa">
                            <div className="single-project"
                                 onClick={() => this.setState({ visaPromIsOpen: true, visaPromPhotoIndex: 0 })}
                                 style={visaPromFirst}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ visaPromIsOpen: true, visaPromPhotoIndex: 1 })}
                                 style={visaPromSecond}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ visaPromIsOpen: true, visaPromPhotoIndex: 2 })}
                                 style={visaPromThird}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ visaPromIsOpen: true, visaPromPhotoIndex: 3 })}
                                 style={visaPromFourth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ visaPromIsOpen: true, visaPromPhotoIndex: 4 })}
                                 style={visaPromFifth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ visaPromIsOpen: true, visaPromPhotoIndex: 5 })}
                                 style={visaPromSixth}>
                            </div>
                        </div>

                        <div id="row" className="row alpack">
                            <div className="single-project"
                                 onClick={() => this.setState({ alpackIsOpen: true, alPackPhotoIndex: 0 })}
                                 style={alpackFirst}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ alpackIsOpen: true, alPackPhotoIndex: 1 })}
                                 style={alpackSecond}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ alpackIsOpen: true, alPackPhotoIndex: 2 })}
                                 style={alpackThird}>
                            </div>
                        </div>

                        <div id="row" className="row agrovojvodina">
                            <div className="single-project"
                                 onClick={() => this.setState({ agroIsOpen: true, agroPhotoIndex: 0 })}
                                 style={agroVojvodinaFirst}>
                            </div>
                        </div>

                        <div id="row" className="row dg">
                            <div className="single-project"
                                 onClick={() => this.setState({ dgIsOpen: true, dgPhotoIndex: 0 })}
                                 style={dgFirst}>
                            </div>
                        </div>

                        <div id="row" className="row glorija">
                            <div className="single-project"
                                 onClick={() => this.setState({ gloriaIsOpen: true, gloriaPhotoIndex: 0 })}
                                 style={glorijaFirst}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ gloriaIsOpen: true, gloriaPhotoIndex: 1 })}
                                 style={glorijaSecond}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ gloriaIsOpen: true, gloriaPhotoIndex: 2 })}
                                 style={glorijaThird}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ gloriaIsOpen: true, gloriaPhotoIndex: 3 })}
                                 style={glorijaFourth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ gloriaIsOpen: true, gloriaPhotoIndex: 4 })}
                                 style={glorijaFifth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ gloriaIsOpen: true, gloriaPhotoIndex: 5 })}
                                 style={glorijaSixth}>
                            </div>
                        </div>
                        
                        <div id="row" className="row goodwill">
                            <div className="single-project"
                                 onClick={() => this.setState({ goodwillIsOpen: true, goodwillPhotoIndex: 0 })}
                                 style={goodWillFirst}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ goodwillIsOpen: true, goodwillPhotoIndex: 1 })}
                                 style={goodWillSecond}>
                            </div>
                        </div>

                        <div id="row" className="row lion-group">
                            <div className="single-project"
                                 onClick={() => this.setState({ lionGroupIsOpen: true, lionGroupPhotoIndex: 0 })}
                                 style={lionGroupFirst}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ lionGroupIsOpen: true, lionGroupPhotoIndex: 1 })}
                                 style={lionGroupSecond}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ lionGroupIsOpen: true, lionGroupPhotoIndex: 2 })}
                                 style={lionGroupThird}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ lionGroupIsOpen: true, lionGroupPhotoIndex: 3 })}
                                 style={lionGroupFourth}>
                            </div>
                        </div>

                        <div id="row" className="row kzlr">
                            <div className="single-project"
                                 onClick={() => this.setState({ lokalniRazvojIsOpen: true, lokalniRazvojPhotoIndex: 0 })}
                                 style={lokalniRazvojFirst}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ lokalniRazvojIsOpen: true, lokalniRazvojPhotoIndex: 1 })}
                                 style={lokalniRazvojSecond}>
                            </div>
                        </div>

                        <div id="row" className="row longavita">
                            <div className="single-project"
                                 onClick={() => this.setState({ longavitaIsOpen: true, longavitaPhotoIndex: 0 })}
                                 style={logavitaFirst}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ longavitaIsOpen: true, longavitaPhotoIndex: 1 })}
                                 style={logavitaSecond}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ longavitaIsOpen: true, longavitaPhotoIndex: 2 })}
                                 style={longavitaThird}>
                            </div>
                        </div>

                        <div id="row" className="row mipseeds">
                            <div className="single-project"
                                 onClick={() => this.setState({ mipSeedsIsOpen: true, mipSeedsPhotoIndex: 0 })}
                                 style={mipSeedsFirst}>
                            </div>
                        </div>

                        <div id="row" className="row office-shoes">
                            <div className="single-project"
                                 onClick={() => this.setState({ officeShoesIsOpen: true, officeShoesPhotoIndex: 0 })}
                                 style={officeShoesFirst}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ officeShoesIsOpen: true, officeShoesPhotoIndex: 1 })}
                                 style={officeShoesSecond}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ officeShoesIsOpen: true, officeShoesPhotoIndex: 2 })}
                                 style={officeShoesThird}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ officeShoesIsOpen: true, officeShoesPhotoIndex: 3 })}
                                 style={officeShoesFourth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ officeShoesIsOpen: true, officeShoesPhotoIndex: 4 })}
                                 style={officeShoesFifth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ officeShoesIsOpen: true, officeShoesPhotoIndex: 5 })}
                                 style={officeShoesSixth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ officeShoesIsOpen: true, officeShoesPhotoIndex: 6 })}
                                 style={officeShoesSeventh}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ officeShoesIsOpen: true, officeShoesPhotoIndex: 7 })}
                                 style={officeShoesEighth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ officeShoesIsOpen: true, officeShoesPhotoIndex: 8 })}
                                 style={officeShoesNinth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ officeShoesIsOpen: true, officeShoesPhotoIndex: 9 })}
                                 style={officeShoesTenth}>
                            </div>
                            <div className="single-project"
                                 onClick={() => this.setState({ officeShoesIsOpen: true, officeShoesPhotoIndex: 10 })}
                                 style={officeShoesEleventh}>
                            </div>
                        </div>

                        <div id="row" className="row zvonko-b">
                            <div className="single-project"
                                 onClick={() => this.setState({ zbIsOpen: true, zbPhotoIndex: 0 })}
                                 style={zbFirst}>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ArhivaCarousel.js